import { ClientTeamMember } from '../generated/graphql';

const buildClientTeamMemberDisplayName = (
  clientTeamMember: Pick<
    ClientTeamMember,
    'id' | 'firstName' | 'lastName' | 'semiUniqueIdentifier'
  >,
) => {
  const { lastName, firstName, semiUniqueIdentifier } = clientTeamMember;
  return `${
    semiUniqueIdentifier ? `${semiUniqueIdentifier} - ` : ''
  }${lastName}, ${firstName}`;
};

export default buildClientTeamMemberDisplayName;
